import { api } from '@/shared/api/client';
import type { Branding, PalettePreview } from '@/shared/branding/branding.types';

/** Public — served before anyone has a session, which is what the login screen needs. */
export const fetchBranding = (): Promise<Branding> => api.get<Branding>('/branding');

export const previewPalette = (brandColor: string): Promise<PalettePreview> =>
  api.post<PalettePreview>('/branding/preview', { brandColor });

export const saveBranding = (siteName: string, brandColor: string): Promise<Branding> =>
  api.put<Branding>('/branding', { siteName, brandColor });

export const removeLogo = (): Promise<Branding> => api.delete<Branding>('/branding/logo');

export const resetBranding = (): Promise<Branding> => api.post<Branding>('/branding/reset');

export async function uploadLogo(file: File): Promise<Branding> {
  const body = new FormData();
  body.append('file', file);

  return api.postForm<Branding>('/branding/logo', body);
}
